<app-loading *ngIf="contentReady"></app-loading>
@if (!afterSendCode) {
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-5 col-md-8 col-sm-12">
      <h1 class="logintext">{{ "Forget password" | translate }}</h1>
      <form class="form" [formGroup]="person" (ngSubmit)="sendEmail()">
        <div class="form-group">
          <label class="label" for="Email">{{ "Email" | translate }}</label>
          <input
            class="input"
            type="text"
            id="Email"
            formControlName="email"
            placeholder="{{ 'Email' | translate }}"
          />
        </div>
        <button type="submit" class="submit-btn login">
          {{ "Send" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
} @else {
<div class="container mb-4">
  <div class="row d-flex justify-content-center align-items-center">
    <div class="col-lg-5 col-md-8 col-sm-12">
      <h2 class="logintext">{{ "Enter the Verification Code" | translate }}</h2>

      <form class="form" [formGroup]="formInfo" (ngSubmit)="onSubmit()">
        <div class="d-flex gap-2 mb-4">
          <input
            type="text"
            class="verify-input"
            formControlName="verificationCode1"
            maxlength="1"
            #verificationCode1
            (input)="moveFocus(verificationCode1, verificationCode2)"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            [(ngModel)]="str1"
            [ngClass]="{
              'is-invalid1':
              (formInfo.controls.verificationCode1.touched &&
              formInfo.controls.verificationCode1.errors) || errorExist ,
              'is-valid':
              formInfo.controls.verificationCode1.touched &&
              formInfo.controls.verificationCode1.errors == null && !errorExist,
              'is-touched':
              formInfo.controls.verificationCode1.untouched &&
              formInfo.controls.verificationCode1.errors == null,
          }"
          />
          <input
            type="text"
            class="verify-input"
            formControlName="verificationCode2"
            maxlength="1"
            #verificationCode2
            (input)="moveFocus(verificationCode2, verificationCode3)"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            [(ngModel)]="str2"
            [ngClass]="{
              'is-invalid1':
              (formInfo.controls.verificationCode2.touched &&
              formInfo.controls.verificationCode2.errors) || errorExist ,
              'is-valid':
              formInfo.controls.verificationCode2.touched &&
              formInfo.controls.verificationCode2.errors == null && !errorExist,
              'is-touched':
              formInfo.controls.verificationCode2.untouched &&
              formInfo.controls.verificationCode2.errors == null,
          }"
          />
          <input
            type="text"
            class="verify-input"
            formControlName="verificationCode3"
            maxlength="1"
            #verificationCode3
            (input)="moveFocus(verificationCode3, verificationCode4)"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            [(ngModel)]="str3"
            [ngClass]="{
              'is-invalid1':
              (formInfo.controls.verificationCode3.touched &&
              formInfo.controls.verificationCode3.errors) || errorExist ,
              'is-valid':
              formInfo.controls.verificationCode3.touched &&
              formInfo.controls.verificationCode3.errors == null && !errorExist,
              'is-touched':
              formInfo.controls.verificationCode3.untouched &&
              formInfo.controls.verificationCode3.errors == null,
          }"
          />
          <input
            type="text"
            class="verify-input"
            formControlName="verificationCode4"
            maxlength="1"
            #verificationCode4
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
            [(ngModel)]="str4"
            [ngClass]="{
              'is-invalid1':
              (formInfo.controls.verificationCode4.touched &&
              formInfo.controls.verificationCode4.errors) || errorExist ,
              'is-valid':
              formInfo.controls.verificationCode4.touched &&
              formInfo.controls.verificationCode4.errors == null && !errorExist,
              'is-touched':
              formInfo.controls.verificationCode4.untouched &&
              formInfo.controls.verificationCode4.errors == null,
          }"
          />
        </div>
        <h2 class="logintext">{{ "Set New Password" | translate }}</h2>
        <div class="form-group">
          <label class="label" for="Password">{{
            "Password" | translate
          }}</label>
          <input
            class="input"
            id="Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="password"
            placeholder="{{ 'Password' | translate }}"
          />
          <button
            type="button"
            class="hidePasswordBtn"
            (click)="togglePasswordVisibility()"
          >
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>
        <div class="form-group">
          <label class="label" for="c_Password">{{
            "Confirm Password" | translate
          }}</label>
          <input
            class="input"
            id="c_Password"
            type="{{ isPasswordVisible ? 'text' : 'password' }}"
            formControlName="c_Password"
            placeholder="{{ 'Confirm Password' | translate }}"
            [ngClass]="{
              'is-invalid':
                formInfo.controls['c_Password'].touched &&
                formInfo.controls['c_Password'].errors,
              'is-valid':
                formInfo.controls['c_Password'].touched &&
                !formInfo.controls['c_Password'].errors
            }"
          />
          <button
            type="button"
            class="hidePasswordBtn"
            (click)="togglePasswordVisibility()"
          >
            @if(!isPasswordVisible){
            {{ "Show Password" | translate }}
            } @else {
            {{ "Hide Password" | translate }}
            }
          </button>
        </div>

        <button type="submit" class="submit-btn login">
          {{ "Confirm" | translate }}
        </button>
      </form>
    </div>
  </div>
</div>
}
